//
// VisualElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./RendererManagerController";
import "../../models/visualElements/VisualElement";
import "../view/SectionController";
import "@sas-dvr/ltjs-commons/styles/Style";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "@sas-dvr/ltjs-commons/models/warnings/WarningEvent";
import "./VisualElementTypeInfo";
import "../../models/visualElements/actions/AbstractAction";
import "./AboutInfo";
import "../export/ExportDataController";
import "../view/HudController";
import "../../models/SASReport";

var VisualElementController = createModule("BIRD::VisualElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController"], EventDispatcher, [
    {
        READY: 50051,
        REMOVED_OBJECTS: 50030,
        VIEWSET_MULTIPLE_REFERENCES: 50031,
        BUSY: 50049,
        TITLE_CHANGED: 50052,
        TRANSITION_STARTED: 50050,
    },
    ,
    ,
    ,
    {
        supportsInsightReport: [2],
        redispatchReadyEvent: [0],
        updateViewData: [0],
        getVisualElementTypeLabel: [7],
        isZoomOverlaySupported: [2],
        isReady: [2],
        updateWarningStatus: [0],
        getCurrentWarningEvent: [1],
        supportsFeature: [2,4],
        getActions: [[1]],
        getAccessibilityLabel: [7],
        getVisualElementTypeInfo: [1],
        getSpanStyleChain: [1,1,1],
        getHudController: [1],
        getTipStyleChain: [1],
        getTitleAsHTML: [7],
        getStyle: [1],
        notifyContentComplete: [0],
        getExportDataController: [1],
        manuallyDispatchTooltipEventForPickResult: [2,1,1],
        getAccessibilityHint: [7],
        getCompositeMemberVisualElementControllers: [[1]],
        _getTitleStyleChain_oo: [1,1,1],
        getPreferredHeightForConstrainedWidth: [5,5],
        isBusy: [2],
        getInsightReport: [1],
        getVisualElementModel: [1],
        getBackgroundStyleChain: [1],
        getSectionController: [1],
        getPrimaryVisualElementController: [1],
        getAboutInfo: [1],
        renderToSVG: [7,4,4,2],
        getSupplementalVisualElementControllers: [[1]],
        getAllCompositeMemberVisualElementControllers: [[1]],
        getElementContainerStyleChain: [1],
        getInsightReportContent: [7],
        getScrollBarStyleChain: [1],
        supportsCompactFormat: [2],
        getVisualElementName: [7],
        getSVGString: [7,4,4,2,2,2],
        _getTitleStyleChain_o: [1,1],
        getDisplayString: [7],
        getAccessibilityValue: [7],
        updateSelectionsForNodeIds: [2,[1]],
        hideTooltip: [0],
    },
    ,
    ["getTitleStyleChain"],
]);
export default VisualElementController;
